<script setup lang="ts">
  import {
    PrimitivePagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationNext,
    PaginationPrevious,
  } from "@/components/ui/pagination";

  interface Props {
    total: number;
    itemsPerPage?: number;
    defaultPage?: number;
    page?: number;
    siblingCount?: number;
    showEdges?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    itemsPerPage: 20,
    defaultPage: 1,
    page: undefined,
    siblingCount: 1,
    showEdges: true,
  });

  const emit = defineEmits<{
    "update:page": [page: number];
  }>();

  const handlePageChange = (page: number) => {
    emit("update:page", page);
  };
</script>

<template>
  <PrimitivePagination
    v-if="total > itemsPerPage"
    v-slot="{ page: activePage }"
    :total="total"
    :items-per-page="itemsPerPage"
    :default-page="defaultPage"
    :page="page"
    :sibling-count="siblingCount"
    :show-edges="showEdges"
    class="my-4"
    @update:page="handlePageChange">
    <PaginationContent v-slot="{ items }">
      <PaginationPrevious />
      <template v-for="(item, index) in items">
        <PaginationItem
          v-if="item.type === 'page'"
          :key="index"
          :value="item.value"
          :is-active="item.value === activePage">
          {{ item.value }}
        </PaginationItem>
        <PaginationEllipsis
          v-else
          :key="item.type"
          :index="index" />
      </template>
      <PaginationNext />
    </PaginationContent>
  </PrimitivePagination>
</template>
